//NW Video in popup
function nw_video_popup() {
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".video-popup-button");
    if (!btn) return;
    var url = btn.dataset.video; // get video url
    // supports both public (vimeo.com/ID) and private/unlisted (vimeo.com/ID/HASH) share links
    var match = url.trim().match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([0-9a-z]+))?/i);
    var videoId = match ? match[1] : '';
    var videoHash = match && match[2] ? match[2] : '';
    var embedSrc = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1' + (videoHash ? '&h=' + videoHash : '');
    // create iframe
    var iframe = '<iframe src="' + embedSrc + '" style="aspect-ratio: 16 / 9; width: 100%; height: auto; max-width: 100vw; max-height: 100vh;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    // find parent popup container
    const wrapper = btn.closest(".popup-box-wrapper");
    const popupContainer = wrapper ? wrapper.querySelector(".popup-box-container") : null;
    if (popupContainer) nw_open_video_popup(popupContainer, iframe);
  });
}
function nw_open_video_popup(popupContainer, iframe) {
    const content = popupContainer.querySelector('.popup-box-content');
    content.innerHTML = '<div class="video-frame-wrapper"></div>';
    const wrapper = content.querySelector('.video-frame-wrapper');
    if (typeof iframe === 'string') {
        wrapper.innerHTML = iframe;
    } else {
        wrapper.appendChild(iframe);
    }
    popupContainer.classList.add('active');
    document.body.classList.add('stop-scroll');
}

function nw_close_popup(popupContainer) {
    popupContainer.classList.remove('active');
    popupContainer.querySelector('.popup-box-content').innerHTML = '';
    document.body.classList.remove('stop-scroll');
}

// NW Next day cut off/countdown timer
function nw_countdown_timer(){
  //check if block exists
  const block = $('.nw-countdown-timer-block');
  if (block.length === 0){
    return;
  }
  //get timer container and remaining remaining seconds
  const timer_container = block.find('.nw-countdown-timer');
  const countdown_text = timer_container.find('.countdown-text');
  if (countdown_text.hasClass('too-late')){
    return;
  }    
  const countdown_time_span = timer_container.find('.countdown-time');
  const day_after = timer_container.data('day-after');
  let remaining_seconds = parseInt(timer_container.data('remaining'), 10);
  //hide if invalid or expired
  if (isNaN(remaining_seconds)) {
      timer_container.hide();
      return;
  }
  let countdown_time_text = '';
  // deadline expired or under 1 minute - to avoid "0 hours and 0 minutes"
  if (remaining_seconds <= 60) {
      countdown_text.text('Order today to get it by ' + day_after + '.');
      return;
  }
  // countdown still active
  countdown_time_text = nw_update_countdown_text(remaining_seconds, countdown_time_text);
  countdown_time_span.text(countdown_time_text);
  const timer = setInterval(() => {
      remaining_seconds--;
      //console.log(remaining_seconds);
      if (remaining_seconds <= 60) {
          countdown_text.text('Order today to get it by ' + day_after + '.');
          clearInterval(timer);
      } else {
          const new_text = nw_update_countdown_text(remaining_seconds, countdown_time_text);
          if (new_text !== countdown_time_text) {
              countdown_time_span.text(new_text);
              countdown_time_text = new_text;
          }
      }
  }, 1000);
}
//update hours and minutes
function nw_update_countdown_text(seconds, deadline_text) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    //set text vars
    const hours_text = h === 1 ? 'hour' : 'hours';
    const minutes_text = m === 1 ? 'minute' : 'minutes';
  
    const new_text = h + ' ' + hours_text + ' and ' + m + ' ' + minutes_text;
    //console.log(new_text);
    //update countdown text if changed
    if (new_text !== deadline_text) {
        return new_text;
    }
    return deadline_text;
}

//Product page - Payment Options
function nw_payment_options_update_price() {
    if ($('.nw-payment-options-block').length) {
        //get selected value
        $('.js-option').on('change', function() {
            var selectedValue = $(this).val().trim();
            //find the container with the data-variant-prices
            var container = $('.nw-po-options-container');
            var variantPrices = JSON.parse(container.attr('data-variant-prices'));
            //find the matching variant
            var matchedVariant = variantPrices.find(function(v) {
                return v.title === selectedValue;
            });
            if (matchedVariant) {
                $('.nw-po-price-klarna').text(matchedVariant.klarna_price);
                $('.nw-po-price-clearpay').text(matchedVariant.clearpay_price);
            }
        });
    }
}
// START: nw_feefo_stars_product_rating
function nw_wait_for_shadowroot(selector, when_loaded, interval = 100, max_tries = 50) {
  let tries = 0;
  const timer = setInterval(function(){
    const container = jQuery(selector)[0];
    if (container && container.shadowRoot) {
      clearInterval(timer);
      when_loaded(container, container.shadowRoot)
      return;
    }
    if (tries++ >= max_tries) {
      clearInterval(timer);
    }
    //console.log('NW tries' + tries);
  }, interval);
}
function nw_feefo_count_stars(container, shadowRoot) {
  const selector = '.feefo-review-badge-wrapper-product';
  const review_section = '.feefo-review-widget-product';
  setTimeout(function(){
    let numberOfFullStars = 0;
    let stars = jQuery(shadowRoot).find('svg');
      stars.each(function () {
          const title = jQuery(this).find('title').text().trim();
          if (title === 'Filled star') {
              numberOfFullStars++;
          }
      });
      //console.log('NW numberOfFullStars' + numberOfFullStars);
    if(numberOfFullStars >= 4) {
        jQuery(selector).css({'display': 'block'});
        jQuery(review_section).parent().parent().css({'display': 'block'});
    }
  },200);
}
function nw_feefo_stars_product_rating(){  
  const selector = '.feefo-review-badge-wrapper-product';
  const review_section = '.feefo-review-widget-product';
  jQuery(selector).css({'display': 'none'});
  jQuery(review_section).parent().parent().css({'display': 'none'});
  nw_wait_for_shadowroot(selector, nw_feefo_count_stars);
}
// END: nw_feefo_stars_product_rating

function nw_klaviyo_signup_popup(){
  const FORM_ID = 'RZ37xp';

  const openForm = function (e) {
    e.preventDefault();
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(FORM_ID);
      return;
    }
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  };

  const prepare = function (link) {
    // Safari blocks javascript: hrefs ("Cannot Run Script"), so neutralise them before they can be followed.
    if ((link.getAttribute('href') || '').toLowerCase().indexOf('javascript:') === 0) {
      link.setAttribute('href', '#');
    }
    link.setAttribute('role', 'button');
    if (link.dataset.nwKlaviyoBound) return;
    link.dataset.nwKlaviyoBound = 'true';
    link.addEventListener('click', openForm);
  };

  document.querySelectorAll('.klaviyo-signup-popup').forEach(prepare);

  // Catches links rendered after load (e.g. section re-render in the theme editor).
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.klaviyo-signup-popup');
    if (trigger && !trigger.dataset.nwKlaviyoBound) openForm(e);
  });
}

function nw_product_gallery_video_popup() {
    let popup = document.getElementById('nw-product-media-gallery-video-popup');
    if (!popup) {
        popup = document.createElement('div');
        popup.id = 'nw-product-media-gallery-video-popup';
        popup.className = 'popup-box-container';
        popup.innerHTML =
            '<div class="popup-box video-popup-box">' +
            '<div class="row text-right"><button class="close-popup"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></button></div>' +
            '<div class="row popup-box-content close-popup"></div>' +
            '</div>' +
            '<div class="popup-bg close-popup"></div>';
        document.body.appendChild(popup);
    }
    document.querySelectorAll('.media-viewer__item[data-media-type="external_video"]').forEach(function (item) {
        const blocker = document.createElement('span');
        blocker.className = 'nw-video-overlay-button';
        item.style.position = 'relative';
        item.appendChild(blocker);
    });
    document.addEventListener('click', function (e) {
        const overlay = e.target.closest('.media-viewer__item[data-media-type="external_video"] .nw-video-overlay-button');
        if (overlay) {
            const item = overlay.closest('.media-viewer__item[data-media-type="external_video"]');
            const templateEl = item.querySelector('template');
            if (!templateEl || !templateEl.content) return;
            const iframe = templateEl.content.querySelector('iframe');
            if (!iframe) return;
            const clonedIframe = iframe.cloneNode(true);
            nw_open_video_popup(popup, clonedIframe);
            return;
        }
        const closeBtn = e.target.closest('.close-popup');
        if (closeBtn) {
            e.preventDefault();
            const container = closeBtn.closest('.popup-box-container');
            if (container) nw_close_popup(container);
        }
    });
}

document.addEventListener('DOMContentLoaded', function(){
  // Run each independently so one failing init (e.g. jQuery not ready yet, since it loads async) doesn't block the rest.
  [
    nw_video_popup,
    nw_countdown_timer,
    nw_payment_options_update_price,
    nw_feefo_stars_product_rating,
    nw_klaviyo_signup_popup,
    nw_product_gallery_video_popup
  ].forEach(function (fn) {
    try {
      fn();
    } catch (err) {
      console.error(`Unable to run ${fn.name}`, err);  // eslint-disable-line
    }
  });
});

// Comparable Price Drawer (extends SideDrawer pattern)
class NwComparablePriceDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = document.querySelector('.js-overlay');
  }

  connectedCallback() {
    // Move drawer to body to escape parent stacking contexts (guard against re-triggering connectedCallback via appendChild)
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    document.querySelectorAll('[data-comparable-price-drawer-open]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(btn);
      });
    });
  }

  handleClick(evt) {
    if (evt.target.matches('.js-close-drawer') || evt.target.closest('.js-close-drawer') || evt.target === this.overlay) {
      this.close();
    }
  }

  open(opener) {
    this.scrollY = window.scrollY;
    document.body.classList.add('fixed');
    document.body.style.top = `-${this.scrollY}px`;
    document.documentElement.style.height = '100svh';

    this.overlay.classList.add('is-visible');
    this.setAttribute('open', '');
    this.setAttribute('aria-hidden', 'false');
    this.opener = opener;

    this.clickHandler = this.clickHandler || this.handleClick.bind(this);
    this.keyupHandler = (evt) => { if (evt.key === 'Escape') this.close(); };

    this.addEventListener('click', this.clickHandler);
    this.addEventListener('keyup', this.keyupHandler);
    this.overlay.addEventListener('click', this.clickHandler);

    this.focus();
  }

  close() {
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    this.overlay.classList.remove('is-visible');

    document.documentElement.style.height = '';
    document.body.style.top = '';
    document.body.classList.remove('fixed');
    window.scrollTo(0, this.scrollY);

    this.removeEventListener('click', this.clickHandler);
    this.removeEventListener('keyup', this.keyupHandler);
    this.overlay.removeEventListener('click', this.clickHandler);

    if (this.opener) this.opener.focus();
  }
}
customElements.define('nw-comparable-price-drawer', NwComparablePriceDrawer);

if (!customElements.get('nw-slideshow')) {
  class NwSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.slides = Array.from(this.querySelectorAll('.cp-slideshow-with-text__slide'));
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.speed = (Number(this.dataset.speed) || 5) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.editorPaused = false;
      this.hovered = false;

      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);
      this.onMouseEnter = () => {
        this.hovered = true;
        this.stop();
      };
      this.onMouseLeave = () => {
        this.hovered = false;
        this.start();
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.initialized = false;
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
    }

    start() {
      if (this.timer || this.editorPaused || this.hovered || this.reducedMotion || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.showNext(), this.speed);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    showNext() {
      this.showSlide((this.currentIndex + 1) % this.slides.length);
    }

    showSlide(index) {
      if (!this.slides[index] || index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');
      this.slides[index].classList.add('is-active');
      this.slides[index].setAttribute('aria-hidden', 'false');
      this.currentIndex = index;
    }

    onBlockSelect(evt) {
      const slide = evt.target.closest('.cp-slideshow-with-text__slide');
      if (!slide || !this.contains(slide)) return;

      this.editorPaused = true;
      this.stop();
      this.showSlide(Number(slide.dataset.index));
    }

    onBlockDeselect() {
      this.editorPaused = false;
      this.start();
    }
  }

  customElements.define('nw-slideshow', NwSlideshow);
}